




import Vue from "vue";

export default Vue.extend({
  name: "graphicSvgEditor",
  props: {
    svgContentStr: {
      type: String,
      required: true,
    },
  },
});
